export default __webpack_public_path__ + "static/media/boy5.34ce952a.jpg";